// Copyright (c) 2019 Deere & Company

import t from 'tcomb';

const FactoryState = t.struct( {
    factoryCode: t.String,
    factories: t.list( t.Object ),
}, {
    name: 'FactoryState',
    strict: true,
} );

export const getDefaultState = () => new FactoryState( {
    factoryCode: '',
    factories: [],
} );

export default FactoryState;
